import { defineClientModule, type ModuleRoute } from '@/app/module';
import { copy } from './copy';

/**
 * push: the bell and /inbox, Me > Pings (permission, per type toggles, quiet hours, test), the
 * soft ask, and the service worker half in sw-push.ts. Keep this file light: data and lazy imports.
 */
const routes: ModuleRoute[] = [{ path: '/inbox', screen: () => import('./screens/Inbox'), tab: 'me' }];

export default defineClientModule({
  name: 'push',
  routes,
  headerActions: [{ id: 'bell', order: 0, component: () => import('./parts/Bell') }],
  meSections: [{ id: 'pings', order: 20, title: copy.pings.title, component: () => import('./parts/Pings') }],
  init() {
    // Heal the subscription, keep the badge honest, listen to the worker. Loaded after first paint.
    void import('./boot').then((m) => m.startPushSync());
  },
});
